/* Angular Component */
import {
  ChangeDetectorRef,
  Component,
  Input,
  NgZone,
  OnChanges,
  OnInit,
} from "@angular/core";

@Component({
  selector: "icn-image",
  templateUrl: "./image.component.html",
  styleUrls: ["./image.component.scss"],
})
export class ImageComponent implements OnChanges {
  @Input()
  url;

  @Input() defaultImage = "/assets/icons/loader-dots.svg";
  image: string;
  isLoaded = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnChanges() {
    this.loadImage();
  }

  loadImage() {
    this.isLoaded = false;
    this.image = this.defaultImage;
    var image = document.createElement("img");
    image.addEventListener(
      "load",
      (event) => {
        this.isLoaded = true;
        this.image = this.url;
        this.changeDetectorRef.markForCheck();
      },
      false,
    );

    image.src = this.url;
    image.setAttribute("width", "1");
  }
}
